import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../../api/axios';
import { useTranslation } from 'react-i18next';

const VerifyEmail = () => {
    const { token } = useParams();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [status, setStatus] = useState('Verifying...');

    const dataFetchedRef = React.useRef(false);

    useEffect(() => {
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;

        const verify = async () => {
            try {
                // Changed from .post to .post('/verify-email', { token }) as per controller expectation
                await axios.post('/user/verify-email', { token });
                setStatus('Email sucessfully verified! Redirecting to login...');
                setTimeout(() => {
                    navigate('/'); // navigate to home/login
                }, 3000);
            } catch (err) {
                console.error(err);
                setStatus('Verification failed. Invalid or expired token.');
            }
        };

        if (token) {
            verify();
        }
    }, [token, navigate]);

    return (
        <div style={{ textAlign: "center", marginTop: "50px", color: "white" }}>
            <h2>{t('VerifyEmailTitle')}</h2>
            <p>{status}</p>
        </div>
    );
};

export default VerifyEmail;
